import { render, staticRenderFns } from "./form-field.vue?vue&type=template&id=31c5d0d6"
import script from "./form-field.vue?vue&type=script&lang=js"
export * from "./form-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports